import { Form } from '@ampol/design-system';
import { useSelector } from 'react-redux';
import { CardModalFormNames } from './types/CardModalFormNames';
import { ModalSection } from './ModalSection';
import { getAccountOptions } from 'utilities/account-utilities';
import {
  useSelectAllAccounts,
  useSelectCardModalMeta,
} from 'selectors/selectors';

export default function CardModalAccount() {
  const allAccounts = useSelectAllAccounts();
  const allAccountsIsLoading = useSelector(
    (state: any) => state.accountsStore.isAllAccountsLoading
  );
  const meta = useSelectCardModalMeta();
  const accountOptions = getAccountOptions(allAccounts, meta?.accountFlatList);

  const hasMultipleAccounts = accountOptions.length > 1;
  const hasMultipleChildAccounts = Array.isArray(accountOptions?.[0].value);
  const hasMultiple = hasMultipleAccounts || hasMultipleChildAccounts;

  return (
    <div>
      <h3>Account</h3>
      <ModalSection first>
        <Form.DropdownSearch
          name={CardModalFormNames.Account}
          label={'Account'}
          data={accountOptions}
          placeholder={'Select account'}
          allowClear={false}
          loading={allAccountsIsLoading}
          disabled={!hasMultiple || meta?.disableAccountField}
        />
      </ModalSection>
    </div>
  );
}
